import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SVG from 'react-inlinesvg'
import cx from 'clsx'

// Redux
import { setModal } from '~lib/saga/filter/actions'
// Material UI
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Button from '@material-ui/core/Button'
// Components
import CategoryList from '~2024/components/CategoryList'
import { CloseIcon } from '~2024/components/Icons'
// Styles
import useStyles from './Modal.style'

const filterSelector = (state) => state.filter

const Modal = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const { modal: isModal } = useSelector(filterSelector)

  const handleModal = (value) => dispatch(setModal(value))

  return (
    <Dialog
      aria-describedby="transition-modal-description"
      aria-labelledby="transition-modal-title"
      className={cx(classes.modal)}
      fullScreen
      id="sort-filter-modal"
      onClose={() => handleModal(false)}
      open={isModal}
      PaperProps={{
        classes: {
          root: classes.paper,
        },
      }}
    >
      <DialogContent className={cx(classes.contentWrapper)}>
        <Button
          className={cx(classes.modalButton)}
          disableFocusRipple
          disableRipple
          onClick={() => handleModal(false)}
        >
          <SVG
            src={CloseIcon}
            width={14}
            height={14}
            title="Close Modal Window"
            description="Checkmark icon used to close the modal window"
          />
        </Button>
        <div className={cx(classes.content)}>
          <CategoryList />
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default Modal
